import { useObservability } from '../ObservabilityProvider';

export function useMetrics() {
  return useObservability().metrics;
}

export function useLogger() {
  return useObservability().logger;
}

export function useTracing() {
  return useObservability().tracing;
}

export function useAnalytics() {
  return useObservability().analytics;
}

export function useErrors() {
  return useObservability().errors;
}
